module.exports = __webpack_public_path__ + "static/media/MeetingsHistoryEmpty.dd0ea999.png";